module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"AIおすすめキーワードのご案内","description_title":"おすすめキーワードに関するレビューを書いてみてください。","description_content":"何を書くか迷わず、おすすめキーワードに沿ってレビューを書いてみてください。AIがテキストを分析し、キーワードの内容が含まれているか判別します。","disclaimer":"※AI分析に誤差が生じる場合があり、実際の付与ポイントに影響することがあります。"}}')
  delete Component.options._Ctor
}
